import { Icon, Modal, Button } from "semantic-ui-react";
import styled from "styled-components";
import React, { useState } from "react";
import { FluidFormFields } from "../FormFields.component";
import { SectionTitle, useRenderViewChange } from "../common";
import { useFluidForm } from "../FormContext";
import { DragAndDropTable } from "../DragAndDropTable.component";
import { DeleteButton } from "../../../components/DeleteButton";
import { indexBy } from "ramda";
import { EmbeddedStyles } from "../EmbeddedStyles";
export const SectionFields = styled.div.attrs({
    className: 'fluid-section-fields'
}) `
    margin-bottom: 1rem;
    position: relative;
    //border-left: 1px solid #ccc;
    padding-left: 1rem;
    
`;
export const SectionItem = styled.div.attrs({
    className: 'fluid-section-item'
}) `
  margin-top: 1rem;

  margin-bottom: 0.5rem;
    position: relative;

    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    padding-left: 1.2rem;
    &:last-child {
        border-bottom: none;
    }
    
    .delete-icon, .add-icon {
        display: none;
    }
    
    &:hover>.delete-icon, &:hover>.add-icon {
            display: block;
    }

    &:has(>.add-icon:hover) {
        border: 1px dashed #ccc;
    }
    
    
`;
export const DeleteIcon = styled(Icon).attrs({ circular: true, size: "tiny", name: "minus" }) `
    cursor: pointer;
    position: absolute;
    left: 0px;
    top: 3px;
`;
export const AddIcon = styled(Icon).attrs({ circular: true, size: "tiny", name: "plus" }) `
    cursor: pointer;
    position: absolute;
    left: 20px;
    bottom: 0px;
`;
export const AddIconInline = styled(Icon).attrs({ circular: true, size: "tiny", name: "plus" }) `
    cursor: pointer;
    margin-left: 0.5rem;
`;
export function ComposedListFieldComponent({ fieldPath, options }) {
    let configService = useFluidForm();
    const fluidForm = useFluidForm();
    const field = fluidForm.getFieldRenderView(fieldPath);
    const config = fluidForm.getFieldConfigByFieldPath(fieldPath);
    let path = field.fieldPath;
    let layout = configService.getAdditionalConfigValue("styleConfig", "layout") || "main-detail";
    let visibleField = config.styles?.visibleFields || [];
    //TODO: We should use a helpfer for this
    let fieldStylesConfigurations = configService.getAdditionalConfigValue("styleConfig", "fieldStylesConfigurations") || [];
    let fieldStylesConfigurationsMap = indexBy((field) => field.configName, fieldStylesConfigurations);
    let fieldStylesConfiguration = fieldStylesConfigurationsMap[config.name] || { visibleFields: [] };
    useRenderViewChange(field.fieldPath);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [editingIndex, setEditingIndex] = useState(-1);
    const addSection = (path) => {
        configService.insertToComposed(path);
    };
    const removeSection = (path, index) => {
        configService.deleteFromComposed(path, index);
    };
    const openEditModal = (item, index) => {
        setEditingItem(item);
        setEditingIndex(index);
        setModalOpen(true);
    };
    const closeEditModal = () => {
        setModalOpen(false);
        setEditingItem(null);
        setEditingIndex(-1);
    };
    const handleOrderChange = (fromIndex, toIndex) => {
        console.log('ComposedField handleOrderChange called:', { fromIndex, toIndex, itemsLength: items.length });
        // Get current items
        const currentItems = [...items];
        // Remove the item from the source position
        const [movedItem] = currentItems.splice(fromIndex, 1);
        // Insert the item at the destination position
        currentItems.splice(toIndex, 0, movedItem);
        console.log('Updating field value:', { path, oldLength: items.length, newLength: currentItems.length });
        // Update the field value through the configService
        configService.swapComposed(path, fromIndex, toIndex);
    };
    const items = field.value;
    const composedConfig = config;
    const renderTableLayout = () => {
        const columns = [
            ...composedConfig.fields.map(fieldConfig => ({
                key: fieldConfig.key,
                header: fieldConfig.label || fieldConfig.key,
                render: (item, index) => {
                    const field = item.value[fieldConfig.key];
                    return field.active ? (React.createElement("div", { className: "table-cell-content" },
                        React.createElement(FluidFormFields, { field: field, options: { ...options, omitLabel: true } }))) : null;
                }
            })),
            {
                key: "actions",
                header: "Actions",
                width: 1,
                render: (item, index) => (React.createElement(DeleteButton, { iconOnly: true, onConfirm: () => removeSection(path, index), title: "Delete Field", message: "Are you sure you want to delete this field?" }))
            }
        ];
        return (React.createElement(DragAndDropTable, { data: items, columns: columns, onOrderChange: handleOrderChange, footer: React.createElement("tr", null,
                React.createElement("th", { className: "fluid-table-header", colSpan: composedConfig.fields.length + 2 },
                    React.createElement(Icon, { name: "plus", className: "fluid-action-icon", link: true, onClick: () => addSection(path), style: { color: 'white' } }),
                    "Add ",
                    config.label || config.key)), compact: true, celled: true }));
    };
    const renderMainDetailLayout = () => {
        // Get first 3 fields for main-detail layout
        let mainFields = composedConfig.fields;
        if (visibleField.length > 0) {
            mainFields = composedConfig.fields.filter(field => visibleField.includes(field.key));
        }
        const columns = [
            ...mainFields.map(fieldConfig => ({
                key: fieldConfig.key,
                header: fieldConfig.label || fieldConfig.key,
                render: (item, index) => {
                    const field = item.value[fieldConfig.key];
                    return field.active ? (React.createElement("div", { className: "table-cell-content" },
                        React.createElement(FluidFormFields, { field: field, options: { ...options, omitLabel: true } }))) : null;
                }
            })),
            {
                key: "actions",
                header: "Actions",
                width: 1,
                render: (item, index) => (React.createElement(React.Fragment, null,
                    React.createElement(Icon, { name: "edit", className: "fluid-action-icon", link: true, onClick: () => openEditModal(item, index), style: { marginRight: '0.5rem' } }),
                    React.createElement(DeleteButton, { iconOnly: true, onConfirm: () => removeSection(path, index), title: "Delete Section", message: "Are you sure you want to delete this section? This action cannot be undone." })))
            }
        ];
        return (React.createElement(DragAndDropTable, { data: items, columns: columns, onOrderChange: handleOrderChange, footer: React.createElement("tr", null,
                React.createElement("th", { className: "fluid-table-header", colSpan: mainFields.length + 2 },
                    React.createElement(Icon, { name: "plus", className: "fluid-action-icon", link: true, onClick: () => addSection(path), style: { color: 'white' } }),
                    "Add ",
                    config.label || config.key)), compact: true, celled: true }));
    };
    const renderEditModal = () => (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: modalOpen, onClose: closeEditModal, size: "large" },
            React.createElement(Modal.Header, null,
                "Edit ",
                config.label || config.key),
            React.createElement(Modal.Content, null,
                React.createElement(EmbeddedStyles, null, editingItem && (React.createElement("div", { style: { padding: '1rem' } },
                    React.createElement(FluidFormFields, { field: editingItem, options: options }))))),
            React.createElement(Modal.Actions, null,
                React.createElement(Button, { onClick: closeEditModal }, "Close")))));
    return (React.createElement("div", { key: field.key, className: "fluid-composed-field" },
        config.label && React.createElement(SectionTitle, { titleLevel: 2, className: "fluid-section-title" },
            config.label,
            React.createElement(AddIconInline, { className: "fluid-action-icon", onClick: () => {
                    addSection(path);
                } })),
        React.createElement("div", { className: "fluid-table" }, layout === "table" ? renderTableLayout() : renderMainDetailLayout()),
        layout === "main-detail" && renderEditModal()));
}
